import {
  PhArrowsOut,
  PhFrameCorners,
  PhLayout,
  PhRobot,
  PhSun,
  PhTarget,
  PhWarning,
  PhWarningCircle,
} from '@phosphor-icons/vue'
import type { Component } from 'vue'

export const MEDIA_QUERY_KEYS = {
  analysis: (mediaId: string) => ['media-analysis', mediaId] as const,
  media: (mediaId: string) => ['media', mediaId] as const,
  menuItemMedia: (menuItemId: string, purpose?: string) =>
    ['menu-item-media', menuItemId, purpose] as const,
}

export const ISSUE_TYPE_ICONS: Record<string, Component> = {
  composition: PhLayout,
  fake: PhRobot,
  focus: PhTarget,
  framing: PhFrameCorners,
  inaccurate: PhWarningCircle,
  lighting: PhSun,
  resolution: PhArrowsOut,
  unappetizing: PhWarning,
}
